
import { defineComponent } from 'vue';
export default defineComponent({
  setup() {
    window.location.href = '/404.html';
    return {};
  },
});
